<template>
  <div class="detail-item">
    <div class="row">
      <div class="col-12 col-md">
        <h3
          v-if="content.pv_infoblock_products_title"
          v-dynamic-content:pv_infoblock_products_title
        ></h3>
        <p>
          <span
            v-if="countInverters(quote.inverters) === 1 && content.pv_infoblock_products1_text"
            v-dynamic-content:pv_infoblock_products1_text="[
              buildLink(quote.panels),
              buildLink(quote.inverters[0]),
              batteryText,
            ]"
          ></span>
          <span
            v-if="countInverters(quote.inverters) === 2 && content.pv_infoblock_products2_text"
            v-dynamic-content:pv_infoblock_products2_text="[
              buildLink(quote.panels),
              buildLink(quote.inverters[0]),
              buildLink(quote.inverters[1]),
              batteryText,
            ]"
          ></span>
          <span
            v-if="countInverters(quote.inverters) === 3 && content.pv_infoblock_products3_text"
            v-dynamic-content:pv_infoblock_products3_text="[
              buildLink(quote.panels),
              buildLink(quote.inverters[0]),
              buildLink(quote.inverters[1]),
              buildLink(quote.inverters[2]),
              batteryText,
            ]"
          ></span>
          &nbsp;
          <span
            v-if="quote.optimizers && content.pv_infoblock_optimizers_text"
            v-html="optimizerText"
          ></span>
        </p>

        <h3
          v-if="content.pv_infoblock_warranties_title"
          v-dynamic-content:pv_infoblock_warranties_title
        ></h3>

        <p
          class="subtitle font-weight-bold"
          v-if="content.pv_infoblock_warranties_text_sunsure && quote.hasSunsure"
          v-dynamic-content:pv_infoblock_warranties_text_sunsure
        ></p>
        <p
          v-if="content.pv_infoblock_warranties_text_guarantee_production && quote.hasSunsure"
          v-dynamic-content:pv_infoblock_warranties_text_guarantee_production
        ></p>

        <p
          class="subtitle font-weight-bold"
          v-if="content.pv_infoblock_services_subtitle"
          v-dynamic-content:pv_infoblock_services_subtitle
        ></p>
        <p
          v-if="content.pv_infoblock_services_text"
          v-dynamic-content:pv_infoblock_services_text
        ></p>
        <p
          class="subtitle font-weight-bold"
          v-if="content.pv_infoblock_basicwarranties_subtitle"
          v-dynamic-content:pv_infoblock_basicwarranties_subtitle
        ></p>
        <p
          v-if="content.pv_infoblock_basicwarranties_text"
          v-dynamic-content:pv_infoblock_basicwarranties_text
        ></p>
        <p
          class="subtitle font-weight-bold"
          v-if="content.pv_infoblock_workwarranties_subtitle"
          v-dynamic-content:pv_infoblock_workwarranties_subtitle
        ></p>
        <p
          v-if="content.pv_infoblock_workwarranties_text"
          v-dynamic-content:pv_infoblock_workwarranties_text
        ></p>
        <p
          class="subtitle font-weight-bold"
          v-if="content.pv_infoblock_powerguarantee_subtitle"
          v-dynamic-content:pv_infoblock_powerguarantee_subtitle
        ></p>
        <p
          v-if="content.pv_infoblock_powerguarantee_text"
          v-dynamic-content:pv_infoblock_powerguarantee_text
        ></p>
        <p
          class="subtitle font-weight-bold"
          v-if="content.pv_infoblock_battery_guarantee_subtitle && quote.batteries.length"
          v-dynamic-content:pv_infoblock_battery_guarantee_subtitle
        ></p>
        <p
          v-if="content.pv_infoblock_battery_guarantee_text && quote.batteries.length"
          v-dynamic-content:pv_infoblock_battery_guarantee_text
        ></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DetailProductsWarranties',
  props: {
    quote: {
      type: Object,
      required: true,
    },
  },
  mixins: ['pickProductName'],
  methods: {
    countInverters(obj) {
      return Object.keys(obj).length
    },
    buildLink(product) {
      const { datasheet } = product
      const productName = this.pickProductName(product)

      if (datasheet) {
        return `<a target="_blank" href="${datasheet}">${productName}</a>`
      }

      return productName
    },
    returnNameList(productList) {
      const textWithLinks = productList.map((product) => this.buildLink(product))
      return textWithLinks.join(`, `)
    },
    createProductText(productName, products, arrayOfTranslations) {
      const { replaceDynamicContent } = this.$options.filters
      const index = productName === 'batteries' && products.length !== 1 ? 1 : 0
      const translation = arrayOfTranslations[index]
      return replaceDynamicContent(translation, [[this.returnNameList(products)]])
    },
  },
  computed: {
    batteryText() {
      const { batteries } = this.quote
      if (batteries)
        return this.createProductText('batteries', batteries, [
          this.content.pv_infoblock_products_battery,
          this.content.pv_infoblock_products_multiple_batteries,
        ])
      else return ''
    },
    optimizerText() {
      const { optimizers } = this.quote
      if (optimizers && optimizers.length)
        return this.createProductText('optimizers', optimizers, [
          this.content.pv_infoblock_optimizers_text,
        ])
      else return ''
    },
  },
}
</script>
